import Vue from 'vue'

Vue.filter('toDecimal', function (value, length) {
  return Math.floor(value * Math.pow(10, length)) / Math.pow(10, length)
})
